import "@fontsource-variable/geist";
import "@fontsource-variable/jetbrains-mono";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";

import AppError from "./components/app-error";
import Loader from "./components/loader";
import { routeTree } from "./routeTree.gen";
import { orpc, queryClient } from "./utils/orpc";

// After a deploy, an open tab may ask for code files that no longer exist. Reload once to get the new
// version (Vite fires this when a lazily loaded file fails); a flag stops a reload loop.
window.addEventListener("vite:preloadError", (e) => {
  if (sessionStorage.getItem("fw-reloaded")) return;
  e.preventDefault();
  sessionStorage.setItem("fw-reloaded", "1");
  window.location.reload();
});
window.setTimeout(() => sessionStorage.removeItem("fw-reloaded"), 10_000);

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultPendingComponent: () => <Loader />,
  defaultErrorComponent: AppError,
  context: { orpc, queryClient },
  Wrap: function WrapComponent({ children }: { children: React.ReactNode }) {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("app");

if (!rootElement) {
  throw new Error("Root element not found");
}

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<RouterProvider router={router} />);
}
